import type { Signal } from "@preact/signals-react";
import { useSignals } from "@preact/signals-react/runtime";
import clsx from "clsx";

import { NumberUtils } from "@/util/number.utils";

interface Props {
  className?: string;
  cost: Signal<number>;
}

export default function JobCost({ className, cost }: Props) {
  useSignals();
  return <div className={clsx("text-right", className)}>{NumberUtils.formatAsUSCurrency(cost.value)} </div>;
}
